/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function UserNotebookFilledIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="user-notebook-filled"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M3.75 4.5C3.783 3.794 4.099 3.012 4.555 2.555C5.012 2.099 5.794 1.783 6.5 1.75L17.5 1.75C18.206 1.783 18.988 2.099 19.445 2.555C19.901 3.012 20.217 3.794 20.25 4.5L20.25 19.5C20.217 20.206 19.901 20.988 19.445 21.445C18.988 21.901 18.206 22.217 17.5 22.25L6.5 22.25C5.794 22.217 5.012 21.901 4.555 21.445C4.099 20.988 3.783 20.206 3.75 19.5L3.75 4.5ZM12 12.75C13.631 12.75 14.954 11.427 14.954 9.796C14.954 8.165 13.631 6.842 12 6.842C10.369 6.842 9.046 8.165 9.046 9.796C9.046 11.427 10.369 12.75 12 12.75ZM9.653 16.619C10.127 15.677 10.947 15.25 12 15.25C12.52 15.25 12.922 15.363 13.359 15.617C13.576 15.744 13.737 15.868 13.915 16.048C14.094 16.228 14.468 16.777 14.468 16.777C14.436 16.74 14.468 16.777 14.468 16.777C14.759 17.071 15.234 17.073 15.528 16.781C15.822 16.49 15.824 16.015 15.532 15.721C15.532 15.721 15.227 15.241 14.98 14.991C14.733 14.742 14.415 14.497 14.114 14.321C13.514 13.971 12.722 13.75 12 13.75C10.569 13.75 9.097 14.659 8.347 15.879C8.143 16.24 8.27 16.698 8.63 16.902C8.991 17.106 9.449 16.979 9.653 16.619Z" data-tinysvg-shape="compound-path" fillRule="evenodd" stroke="none" fill={color} data-fill-tone="primary" />
          <path d="M2.75 12L6.25 12" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M2.75 6L6.25 6" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M2.75 18L6.25 18" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
